/**
 * RecentAssets.jsx
 * The last few things uploaded or generated, and the shortcut into the
 * generator.
 *
 * Dependencies: helpers.js, services/api.js
 */

import { Image, Sparkle, Upload } from '../Icons.jsx';
import { api } from '../../services/api.js';
import { ago } from './helpers.js';

export default function RecentAssets({ assets = [], navigate }) {
  return (
    <section className="card">
      <div className="card__head">
        <span className="tile">
          <Image size={21} />
        </span>
        <div className="card__head-text">
          <h2>Recent assets</h2>
          <p>Your latest uploads and generated pictures.</p>
        </div>
        <div className="card__head-end">
          <button className="btn btn--sm" onClick={() => navigate('/library')}>
            View all
          </button>
        </div>
      </div>

      {assets.length === 0 ? (
        <div className="empty empty--inline">
          <div className="empty__art">
            <Upload size={26} />
          </div>
          <h3>Nothing in the library yet</h3>
          <p>Upload a picture or generate one, and it will show up here.</p>
          <button className="btn btn--primary" onClick={() => navigate('/library')}>
            <Upload /> Upload
          </button>
        </div>
      ) : (
        <div className="asset-grid">
          {assets.map((asset) => (
            <button
              className="asset"
              key={asset.id}
              type="button"
              onClick={() => navigate('/library')}
              title={`${asset.brand_name} · ${ago(asset.created_at)}`}
            >
              {asset.kind === 'video' ? (
                <video src={api.media.rawUrl(asset.id)} muted playsInline preload="metadata" />
              ) : (
                <img
                  src={api.media.rawUrl(asset.id)}
                  alt={asset.alt_text || asset.original_name || ''}
                  loading="lazy"
                />
              )}
              {/* Generated pictures are marked, because "did we make this or
                  did the client send it" is asked about every single image. */}
              {asset.source !== 'upload' && (
                <span className="asset__flag">
                  <Sparkle size={12} />
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </section>
  );
}

// ============================================
// THE AI SHORTCUT
// ============================================

/**
 * Not a summary of anything — a way in. It sits on the dashboard because the
 * generator is the thing people open the app to use, and hunting for it
 * through the menu every time is friction with no purpose.
 */
export function AiAssistant({ navigate }) {
  return (
    <section className="card card--feature">
      <div className="card__head">
        <span className="tile">
          <Sparkle size={21} />
        </span>
        <div className="card__head-text">
          <h2>AI content assistant</h2>
          <p>Captions, pictures and a week of posts, in your brand's voice.</p>
        </div>
      </div>

      <ul className="feature-list">
        <li>Captions written from your brand tone and banned claims</li>
        <li>Pictures generated to the right shape for each platform</li>
        <li>A whole campaign week planned, then approved by you</li>
        <li>Hashtag sets researched against real Instagram figures</li>
      </ul>

      <div className="btn-row">
        <button className="btn btn--primary" onClick={() => navigate('/create')}>
          <Sparkle size={16} /> Generate content
        </button>
        <button className="btn" onClick={() => navigate('/campaigns')}>
          Plan a campaign
        </button>
      </div>
    </section>
  );
}
